import { __ } from '@wordpress/i18n'

import { 
	ServerSideRender, PanelBody, TextControl
} from '@wordpress/components'

import { addFilter } from '@wordpress/hooks'
import { compose } from '@wordpress/compose'
import {
	withTabbedInspector
} from '~cartzillagb/higher-order'
import { i18n } from 'cartzillagb'
import classnames from 'classnames'


addFilter( 'cartzillagb.hero-search-form.edit.inspector.style.before', 'cartzillagb/hero-search-form', ( output, props ) => {
	const { 
		attributes, setAttributes, classnames 
	} = props
	const {
		keywordsPlaceholderText,
		dropdownText
	} = props.attributes


	return (
		<PanelBody title={ __( "General Settings", i18n ) } initialOpen={ true }>
			<TextControl
                label={ __( 'Keywords Placeholder', i18n ) }
                value={ keywordsPlaceholderText }
                onChange={ keywordsPlaceholderText => setAttributes( { keywordsPlaceholderText } ) }
            />

            <TextControl
                label={ __( 'All Categories Text ', i18n ) }
                value={ dropdownText }
                onChange={ dropdownText => setAttributes( { dropdownText } ) }
            />
							
		</PanelBody>
		
	)
} )

const edit = props => {
	return (
		<ServerSideRender
			block="czgb/hero-search-form"
			attributes={{
               keywordsPlaceholderText: props.attributes.keywordsPlaceholderText,
               dropdownText: props.attributes.dropdownText
            }}
		/>
	)
}

export default compose(
	withTabbedInspector( [ 'style','advanced' ] ),
)( edit )